
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";

interface ConsentSectionProps {
  consentChecked: boolean;
  setConsentChecked: (checked: boolean) => void;
}

const ConsentSection = ({ consentChecked, setConsentChecked }: ConsentSectionProps) => {
  return (
    <div className="flex items-start space-x-2 pt-2">
      <Checkbox 
        id="consent" 
        checked={consentChecked}
        onCheckedChange={(checked) => setConsentChecked(checked === true)} 
      />
      <Label 
        htmlFor="consent" 
        className="text-sm leading-tight cursor-pointer"
      >
        I consent to Aurora Multimedia Corp using my information to send me news, updates and promotional content
      </Label>
    </div>
  );
};

export default ConsentSection;
